import { render, staticRenderFns } from "./import.vue?vue&type=template&id=a94f9c80&scoped=true"
import script from "./import.vue?vue&type=script&lang=ts"
export * from "./import.vue?vue&type=script&lang=ts"
import style0 from "./import.vue?vue&type=style&index=0&id=a94f9c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f9c80",
  null
  
)

export default component.exports